<div class="container">
  <div class="controls">
    <app-sku-file-upload></app-sku-file-upload>
    <div class="title">{{ title }}</div>
    <div>
      <app-sku-download-template></app-sku-download-template>
      <app-generate-guid
        class="generate-guid"
        [buttonLabel]="guidButtonLabel"
        *ngIf="showGuidButton"
      ></app-generate-guid>
      <app-download-all
        *ngIf="downloadAllConfig"
        [config]="downloadAllConfig"
      ></app-download-all>
    </div>
  </div>

  <div class="history">
    <app-sku-upload-history></app-sku-upload-history>
  </div>
</div>
